import { AllRfqThemeSizeConfig } from './types';

const large: AllRfqThemeSizeConfig = {
  allRfq: {},
};

export default large;
